
import { Route } from '@angular/router';
import { MainAppLayoutComponent } from './layout/main-app-layout.component';
import { authenGuard } from './core/guards/authen.guard';



export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/app'
  },
  {
    path: 'auth-callback',
    loadChildren: () => import('./feature/auth-callback/routes').then(r => r.routes)
  },
  {
    path: 'login',
    loadChildren: () => import('./feature/login/routes').then(r => r.ROUTER)
  },
  {
    path: 'app',
    component: MainAppLayoutComponent,
    canActivate: [authenGuard],
    canActivateChild: [authenGuard],
    children: [
      {
        path: 'fo',
        loadChildren: () => import("@poc-monorepo/featureone").then(m => m.ROUTES_FEATURE_ONE),
        data: {
          header: "เมนูชื่อ Fo"
        },
      },
      {
        path: 'gun',
        loadChildren: () => import("@poc-monorepo/waterwork").then(m => m.ROUTER),
        data: {
          header: "เมนูชื่อ Gun"
        },

      },
      {
        path: 'set-plan',
        loadChildren: () => import("@poc-monorepo/set-plan").then(m => m.ROUTER),
        data: {
          header: "แผนงาน"
        },

      },
      {
        path: 'approve-plan',
        loadChildren: () => import("@poc-monorepo/set-plan").then(m => m.ROUTER),
        data: {
          header: "แผนงาน"
        },

      },
      {
        path: 'create-user',
        loadChildren: () => import("@poc-monorepo/create-user").then(m=>m.ROUTER),
        data: {
          header: "จัดการผู้ใช้งาน"
        },

      },
      {
        path: 'edit-profile',
        loadChildren: () => import("@poc-monorepo/edit-profile").then(m=>m.ROUTER),
        data: {
          header: "ข้อมูลผู้ใช้งาน"
        },

      },
      {
        path: 'report',
        loadChildren: () => import("@poc-monorepo/report").then(m=>m.ROUTER),
        data: {
          header: "รายงาน"
        },

      },
      {
        path: 'settings/wwcode',
        loadChildren: () => import("@poc-monorepo/wwcode_and_branch").then(m=>m.ROUTER),
        data: {
          header: "สร้างBA/หน่วยงาน"
        },

      },
      {
        path: 'manage-plan',
        loadChildren: () => import("@poc-monorepo/manage-plan").then(m => m.ROUTER),
        data: {
          header: "จัดการแผนงาน"
        },

      },
      {
        path: 'master-plan',
        loadChildren: () => import("@poc-monorepo/master-plan").then(m => m.ROUTER),
        data: {
          header: "จัดการแผนหลัก"
        },

      },
      {
        path: 'cis-log',
        loadChildren: () => import("@poc-monorepo/cis-log").then(m => m.ROUTER),
        data: {
          header: "CIS Response Log"
        },

      },
      {
        path: 'cis-api-log',
        loadChildren: () => import("@poc-monorepo/cis-log").then(m => m.CIS_API_LOG_ROUTER),
        data: {
          header: "CIS API Log"
        },

      },
      {
        path: 'approve-manage-plan',
        loadChildren: () => import("@poc-monorepo/manage-plan").then(m => m.ROUTER),
        data: {
          header: "ขออนุมัติเปลี่ยนแปลงแผน"
        },

      },
      {
        path: 'dashboard',
        loadChildren: () => import("@poc-monorepo/dashboard").then(m => m.ROUTER),
        data: {
          header: "ภาพรวมการจดมาตร"
        },

      },
      {
        path: 'dashboard-overview',
        loadChildren: () => import("@poc-monorepo/dashboard").then(m => m.OVERVIEW_ROUTER),
        data: {
          header: "ภาพรวมประจำเดือน"
        },
      },
      {
        path: 'submit-invoice',
        loadChildren: () => import("@poc-monorepo/submit-invoice").then(m => m.ROUTER),
        data: {
          header: "การอ่านมาตรวัดน้ำ"
        },

      },
      {
        path: 'submit-invoice-response',
        loadChildren: () => import("@poc-monorepo/submit-invoice-response").then(m => m.ROUTER),
        data: {
          header: "ผลการอ่านมาตรวัดน้ำ"
        },

      },
      {
        path: 'invoice-report',
        loadChildren: () => import("@poc-monorepo/report").then(m => m.ROUTER2),
        data: {
          header: "ใบแจ้งหนี้"
        },

      },
      {
        path: 'setting-invoice',
        loadChildren: () => import("@poc-monorepo/report").then(m => m.SETTINGINVOICEROUTER),
        data: {
          header: "กำหนดค่าใบแจ้งหนี้"
        },

      },
      {
        path: 'report-verification',
        loadChildren: () => import("@poc-monorepo/report").then(m => m.ROUTERREPORTVERIFY),
        data: {
          header: "รายงานการตรวจสอบข้อมูล"
        },

      },
      {
        path: 'admin-district',
        loadChildren: () => import("@poc-monorepo/create-user").then(m => m.ROUTERADMIN_DISTRICT),
        data: {
          header: "กำหนดสิทธิเขต"
        },

      },
      {
        path: 'admin-branch',
        loadChildren: () => import("@poc-monorepo/create-user").then(m => m.ROUTERBRANCH),
        data: {
          header: "กำหนดสิทธิสาขา"
        },

      },
      {
        path: 'branch-users',
        loadChildren: () => import("@poc-monorepo/create-user").then(m => m.ROUTERBRANCHUSERS),
        data: {
          header: "จัดการผู้ใช้สาขา"
        },
      },
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/login'
  }
];
